export const SAVE_PROMPT_TOOL_NAME = "save_prompt";
